/**
 * Given the current path, returns the module list URL when the user is on a
 * detail (`show/:id`) or edit (`update/:id`) page; otherwise null.
 * The list URL is the first two path segments: `/<scope>/<entity>`, which is
 * the list route for every module. The only nested detail
 * (`/tool/management-report/execution/show/:id`) lands on the parent report
 * list instead of its executions list — an acceptable, always-valid fallback.
 */
export function getModuleListUrl(currentPath: string): string | null {
  const path = currentPath.split('?')[0].split('#')[0];
  const segments = path.split('/').filter(Boolean);
  const isDetailOrEdit =
    segments.includes('show') || segments.includes('update');
  if (!isDetailOrEdit || segments.length < 2) return null;
  return `/${segments[0]}/${segments[1]}`;
}
